export default __webpack_public_path__ + "static/media/testimonials@3x.187dbbe1.png";